export default "__VITE_ASSET__6cc80497__"